import api from "!../../../node_modules/style-loader/dist/runtime/injectStylesIntoStyleTag.js";
            import content from "!!../../../node_modules/css-loader/dist/cjs.js!../../../node_modules/mini-css-extract-plugin/dist/loader.js??ruleSet[1].rules[5].use[0]!../../../node_modules/css-loader/dist/cjs.js!./fwobusinessabnselector.css";

var options = {};

options.insert = "head";
options.singleton = false;

var update = api(content, options);



export default content.locals || {};